import DeviceDetector from "device-detector-js";
// import DeviceDetector from 'node-device-detector';
import {Device} from "@/utils/index";

let UserAgentData;
export default {
	getDeviceDetector(){
		if(!this.deviceDetector){
			this.deviceDetector = new DeviceDetector({
				clientIndexes: true,
				deviceIndexes: true,
				deviceAliasCode: false,
			});
		}
		return this.deviceDetector;
	},
	async getUserAgentData () {
		if(!navigator.userAgentData){
			return null;
		}
		if(UserAgentData){
			return UserAgentData;
		}
		UserAgentData = await navigator.userAgentData.getHighEntropyValues([
			'platform',
			'platformVersion',
			'model',
			'architecture',
			'bitness',
			'uaFullVersion'
		]);
		return UserAgentData;
	},
	parse(ua){
		let detector = this.getDeviceDetector();
		let info;
		if(detector.parse){
			info = detector.parse(ua);
		}else{
			info = detector.detect(ua);
		}

		// ios safari parse
		(() => {
			if(info.os.name !== 'iOS') return;
			// Mozilla/5.0 (iPad; CPU OS 18_3_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) EdgiOS/134.0.3124.95 Version/18.0 Mobile/15E148 Safari/604.1
			// Mozilla/5.0 (iPhone; CPU iPhone OS 18_3_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) EdgiOS/134.0.3124.95 Version/18.0 Mobile/15E148 Safari/604.1
			let pua = ua.toLowerCase();
			if(!pua.includes('safari')) return;

			if(!info.client.version){
				// Mozilla/5.0 (iPhone; CPU iPhone OS 18 3 2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 Safari/604.1 KAKAOTALK/25.2.2 (INAPP)
				if(info.os.version){
					info.client.version = info.os.version;
				}
			}else if(pua.includes('edgios')){
				let idx = pua.indexOf('edgios/');
				if(idx < 0) return;
				let verIdx = pua.indexOf('version/', idx);
				if(verIdx < 0) return;

				let versionStr = pua.substring(verIdx + 'version/'.length, pua.indexOf(' ', verIdx));
				Object.assign(info.client, {
					// engine: "WebKit",
					// engineVersion:"605.1",
					// type:"browser",
					name: "Mobile Safari",
					version: versionStr
				});
			}
		})();

		(() => {
			if(!UserAgentData) return;
			if(UserAgentData.platform){
				info.os.name = UserAgentData.platform;
			}
			if(UserAgentData.platformVersion){
				info.os.version = UserAgentData.platformVersion;
			}
			if(UserAgentData.brands){
				if(info.client.name?.includes('hrome')){
					let brand = UserAgentData.brands.find(b => b.brand.includes('Chrome'));
					if(brand){
						info.client.version = brand.version;
					}
				}
			}
			if(UserAgentData.mobile !== undefined){
				info.mobile = UserAgentData.mobile;
			}
		})();

		return info;
	},
	async detectDevice() {
		const html = document?.documentElement;
		if(!html){
			return;
		}

		const ua = navigator?.userAgent;
		if (!ua) {
			return;
		}

		// const deviceDetector = getDeviceDetector();
		await this.getUserAgentData();
		const device = this.parse(ua);

		const data = {};
		let setData = (c1, c2) => {
			c2.forEach(n => {
				data[`grm-${c1}-${n}`] = device[c1] ? device[c1][n]?.toLowerCase() : '';
			});
		};
		setData('client', ['type', 'name', 'version']);
		setData('os', ['name', 'version']);
		setData('device', ['type', 'brand']);
		if(
			['smartphone', 'tablet'].includes(data['grm-device-type']) ||
			data['grm-client-name'].includes('mobile') ||
			(data['grm-os-name'] === 'mac' && navigator.maxTouchPoints > 2) ||
(			data['grm-os-name'] === 'gnu/linux' && navigator.maxTouchPoints > 2)
		) {
			data['grm-device-mobile'] = ''
		}

		for (let key in data) {
			if(
				key === 'grm-device-type' && data['grm-os-name'] === 'mac' && navigator.maxTouchPoints > 2
				|| key === 'grm-device-type' && data['grm-os-name'] === 'gnu/linux' && navigator.maxTouchPoints > 2
			){
				html.setAttribute(key, 'tablet');
				continue;
			}
			html.setAttribute(key, data[key]);
		}
	},
	deviceInfo(create) {
		const ua = navigator?.userAgent;
		if (!ua) {
			return;
		}

		if(create !== true){
			if(this._device){
				return this._device;
			}
		}

		// const deviceDetector = getDeviceDetector();
		const device = this.parse(ua);
		device.toString = () => {
			return JSON.stringify(device);
		}
		this._device = device;
		return device;
	},
	isMobile() {
		const html = document?.documentElement;
		const isMobile = html.hasAttribute('grm-device-mobile');
		return isMobile;
	},
	isAndroid() {
		const html = document?.documentElement;
		const is = html.getAttribute('grm-os-name') === 'android';
		return is;
	},
	isIOS() {
		const html = document?.documentElement;
		const isIOS = html.getAttribute('grm-os-name') === 'ios'
		|| (html.getAttribute('grm-os-name') === 'mac' && navigator.maxTouchPoints > 2);
		return isIOS;
	},
	isTablet() {
		const html = document?.documentElement;
		const isTablet = html.getAttribute('grm-device-type') === 'tablet';
		return isTablet;
	},
	isSafari() {
		const html = document?.documentElement;
		const clientName = html.getAttribute('grm-client-name');
		const isSafari = clientName?.includes('safari');
		return isSafari;
	},
	isIOSSafari() {
		return this.isIOS() && this.isSafari();
	},
	osVersion() {
		const html = document?.documentElement;
		const osVersion = html.getAttribute('grm-os-version');
		return osVersion;
	},
	orientationchange() {
		if (!globalThis.window) {
			return;
		}

		window.addEventListener('orientationchange', () => {
			document.documentElement.style.height = '100vh';
			setTimeout(() => {
				document.documentElement.style.height = '100%';
			}, 500)
		})
	},
	networkType() {
		const connection = navigator?.connection;
		if (!connection) {
			return;
		}

		const type = !connection.type || connection.type === 'unknown'
			? null
			: connection.type

		return type;
	},
	portrait() {
		return (globalThis.innerHeight / globalThis.innerWidth) > 1;
	},

	isBrowserAvailable(name, version){
		if(Array.isArray(name)){
			let chk = name.find((obj) => {
				let name, version;
				if(Array.isArray(obj)){
					name = obj[0];
					version = obj[1];
				}else{
					name = obj.name || obj.n;
					version = obj.version || obj.v;
				}
				return this.isBrowserAvailable(name, version) !== true;
			})
			if(chk) return false;
			return true;
		}

		const info = this.deviceInfo();
		const currentName = info.client?.name?.toLowerCase();
		const currentVersion = parseFloat(info.client.version);

		name = name.toLowerCase();
		if(currentName === name){
			return currentVersion >= version;
		}

		switch(name){
			case 'msafari':
			case 'mobile safari':
			case 'safari':{
				if(currentName.includes('safari')){
					return currentVersion >= version;
				}
				break;
			}
			case 'mchrome':
			case 'chrome mobile':
			case 'chrome': {
				if(currentName.includes('chrome')){
					return currentVersion >= version;
				}
				break;
			}
		}

		return true;
	},
}